import type { CSSProperties } from "react";
import { getProjectIconPalette } from "@libs/zapi-ui/const";

// Sets --project-page-bg, consumed by the `projectPage` Tailwind color (e.g. bg-projectPage).
export function projectPageBackgroundStyle(iconColor: string | null | undefined): CSSProperties {
  return { "--project-page-bg": getProjectIconPalette(iconColor).pageBackground } as CSSProperties;
}
